module.exports = __webpack_public_path__ + "img/banner3.4d07fd35.webp";